import type { TypographyProps } from './Typography';
import { Typography } from './Typography';

export type TextBaseProps = Pick<
  TypographyProps,
  | 'label'
  | 'color'
  | 'ellipsis'
  | 'uppercase'
  | 'textAlign'
  | 'role'
  | 'verticalTextAlign'
  | 'newLineBreak'
>;

export const TextBase = ({
  ellipsis,
  label,
  uppercase,
  textAlign,
  verticalTextAlign = 'align-baseline',
  color = 'text-ds-natural',
  role,
  newLineBreak,
}: TextBaseProps) => (
  <Typography
    uppercase={uppercase}
    ellipsis={ellipsis}
    color={color}
    label={label}
    textAlign={textAlign}
    verticalTextAlign={verticalTextAlign}
    role={role}
    tagName="span"
    fontSize="text-ds-400"
    lineHeight="leading-ds-300"
    fontWeight="font-ds-normal"
    newLineBreak={newLineBreak}
  />
);
